import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import ModuleQuestion from "../../components/ModuleQuestion";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.4.9 Practice Case 7
            </h1>
            <p className="me-4">Estimated time to complete: 5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="A"
            assessmentName="practice_case_7"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                </p>
                <p>
                  This is Practice Case Number 7. This is a positive case. The
                  size and contrast have already been adjusted. Starting at the
                  bottom of the brain and moving superiorly, we enter into the
                  cerebellum, where normal gray-white contrast is see
                  throughout. Again, as we move upwards, we enter into the
                  temporal lobes, seen here and here. Anterior to the temporal
                  lobes, you can see some uptake located here and here. This
                  activity is not within the temporal lobes. If you wish to
                  further localize it, utilize the accompanying fused images on
                  your viewer. As we move upwards, we enter into the temporal
                  and occipital regions together. Normal white matter tracts can
                  be see here and also on the right-hand side, here. As we move
                  upwards, this pattern of white matter tracts and normal
                  gray-white contrast continues to be seen on the left-hand side
                  within the temporal and occipital lobes. On the right-hand
                  side, white matter tracts can also be seen in the temporal
                  lobes. However, in the right occipital region, there is some
                  mild loss of gray-white contrast here. As we move upwards,
                  normal with matter tracts continue to be see on the left-hand
                  side. But in the right occipital region, intense uptake can be
                  seen here. On this slice, intense uptake is see extending into
                  the gray matter and exceeds that of the adjacent white matter.
                  This is an example of where a single area of intense uptake is
                  sufficient for the scan to be called positive. As we continue
                  moving upwards, we enter into the frontal cortices here and
                  here. Although normal gray-white contrast is likely seen, it
                  is complicated by the presence of atrophy, see here and likely
                  here. Atrophy makes it a little bit difficult to evaluate the
                  presence of gray-white contrast.
                </p>
                <p>
                  However, if we switch to the PET-CT fused images and look
                  here, it is clear that this area of decreased uptake is
                  actually within a sulcus. Returning to the PET images, we can
                  continue our evaluation. The area of abnormal tracer uptake
                  seen in the occipital region extends into the uppermost
                  portions of the occipital lobe. However, as we continue
                  upwards, we continue to see normal white matter tracts in the
                  parietal region on the left-hand side and the right-hand side.
                  Therefore, there is also preservation of normal gray-white
                  contrast throughout the parietal lobe. Returning to this area,
                  we have a case that is positive because of intense gray matter
                  uptake. This meets the criteria for a single area with intense
                  gray matter uptake that exceeds white matter uptake. Thus,
                  this case is positive for moderate to frequent amyloid
                  neuritic plaques.
                </p>
              </>
            }
            previousLesson="/module-2/module-2-4-8"
            nextLesson="/module-2/module-2-4-10"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1248395932&entry_id=1_7ktku4pe&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="practice"
            videoId="1_7ktku4pe"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
